import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";

import {
  Button,
  ModalView,
  Container,
  Row,
  Col,
  Table,
  LoadingIndicator
} from "../../components/simple";
import AudienceRow from "../Audience/AudienceRow";

import * as routes from "../../router/routes";
import Api from "../../api";

import Header from "../../components/complex/Header";
import { checkPermissions, permissions } from "../../components/permissions";

const Trash = props => {
  const [state, setState] = useState({
    isShowConfirmModal: false,
    confirmModalLabel: "",
    confirmButtonLabel: "Confirm",
    confirmAction: null
  });

  const {
    user,
    removedAudiences,
    isRemovedAudiencesLoading,
    isRestoreAllAudiencesSuccess,
    isRestoreAudienceSuccess,
    isPermanentRemoveAllSuccess,
    isAudienceRemoveSuccess
  } = props;

  const handleAudienceRowClick = audience => {
    const { history } = props;

    const permitted = checkPermissions(
      user.company.currentSubscription,
      permissions.preCampaignReport.view
    );

    if (!permitted) {
      return;
    }

    if (audience.audienceVariables && audience.audienceVariables.length) {
      history.push({
        pathname: `${routes.fullReport}/${audience.id}/${audience.threshold}/audience`,
        state: { audience }
      });
    } else if (!audience.audienceVariables) {
      history.push({
        pathname: `${routes.fullReport}/${audience.id}/${audience.threshold}/preset`,
        state: { audience }
      });
    }
  };

  const handleRemoveAudience = audienceId => {
    setState({
      ...state,
      isShowConfirmModal: true,
      confirmModalHeader: "Remove audience",
      confirmModalLabel: "Are you sure?",
      confirmButtonLabel: "Remove permanently",
      confirmAction: () => {
        Api.audience.remove({ id: audienceId });
      }
    });
  };

  const handleRemoveAll = () => {
    setState({
      ...state,
      isShowConfirmModal: true,
      confirmModalHeader: "Remove all",
      confirmModalLabel: "Are you sure?",
      confirmButtonLabel: "Remove all permanently",
      confirmAction: () => {
        Api.audience.removeAllAudiences();
      }
    });
  };

  const handleRestoreAll = () => {
    setState({
      ...state,
      isShowConfirmModal: true,
      confirmModalHeader: "Restore all",
      confirmModalLabel: "Are you sure?",
      confirmButtonLabel: "Restore all",
      confirmAction: () => {
        Api.audience.restoreAllAudiences();
      }
    });
  };

  useEffect(() => {
    Api.audience.getRemovedAudiences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => {
      if (
        isRestoreAllAudiencesSuccess ||
        isRestoreAudienceSuccess ||
        isPermanentRemoveAllSuccess ||
        isAudienceRemoveSuccess
      ) {
        Api.audience.getRemovedAudiences();
        setState({ ...state, isShowConfirmModal: false });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      isRestoreAllAudiencesSuccess,
      isRestoreAudienceSuccess,
      isPermanentRemoveAllSuccess,
      isAudienceRemoveSuccess
    ]
  );

  return (
    <Container id="audiences" fluid>
      <div
        className="audiences-background"
        style={{ height: 310, overflow: "hidden" }}
      >
        <div className="background-light" />
      </div>
      <Container className="audiences-container">
        <Row>
          <Header isShowProfilePopover={state.isShowProfilePopover} />
        </Row>
        <Row className="audiences-dashboard">
          <div className="dashboard">
            <Col className="dashboard-container">
              <h1 className="title">Trash bin</h1>
              <p className="description">
                Below are all audiences that you removed from the audience list.
              </p>
            </Col>
            <Col className="dashboard-container">
              {props.user.company && (
                <div className="d-flex ml-auto">
                  <Button
                    onClick={handleRestoreAll}
                    className="button analysis-button"
                  >
                    <span>Restore all</span>
                  </Button>

                  <Button
                    onClick={handleRemoveAll}
                    className="button button-danger"
                  >
                    <span>Empty trash</span>
                  </Button>
                </div>
              )}
            </Col>
          </div>
        </Row>

        <Row className="audiences-content">
          {removedAudiences?.length ? (
            <Table>
              <thead>
                <tr>
                  <th className="name">Name</th>
                  <th className="id">ID</th>
                  <th className="reach">Reach</th>
                  <th className="type">Type</th>
                  <th className="country">Country</th>
                  <th className="created-at">Created</th>
                  <th className="quality-indicator">Quality Indicator</th>
                  <th className="options"></th>
                </tr>
              </thead>
              <tbody>
                {removedAudiences?.map(audience => {
                  return (
                    <AudienceRow
                      key={`audience-row-${audience.id}`}
                      isTrashRow
                      audience={audience}
                      canEdit={
                        audience.audienceVariables
                          ? user?.role === "admin" || user?.role === "gdr admin"
                          : false
                      }
                      canRemove={
                        audience.audienceVariables
                          ? user?.role === "admin" || user?.role === "gdr.admin"
                          : false
                      }
                      user={user}
                      onRemove={() => {
                        handleRemoveAudience(audience?.id);
                      }}
                      onClick={() => {
                        handleAudienceRowClick(audience);
                      }}
                      onRestore={() => {
                        Api.audience.restoreAudience({
                          data: { audienceId: audience?.id }
                        });
                      }}
                    />
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <>
              {!isRemovedAudiencesLoading ? (
                <div
                  style={{
                    width: "100%",
                    color: "#8596AF",
                    textAlign: "center"
                  }}
                >
                  Trash is empty
                </div>
              ) : null}
            </>
          )}
          {isRemovedAudiencesLoading && (
            <div style={{ margin: "0 auto" }}>
              <LoadingIndicator />
            </div>
          )}
        </Row>
      </Container>

      <ModalView
        isOpen={state.isShowConfirmModal}
        toggle={() => {
          setState({ ...state, isShowConfirmModal: false });
        }}
        changeModalState={() => {
          setState({ ...state, isShowConfirmModal: false });
        }}
        handleClose={() => {
          setState({ ...state, isShowConfirmModal: false });
        }}
      >
        <h2 className="title text-center mb-3">{state.confirmModalHeader}</h2>
        <p className="description mb-4" style={{ textAlign: "center" }}>
          {state.confirmModalLabel}
        </p>
        <div className="buttons-container">
          <Button
            onClick={() => {
              state.confirmAction();
            }}
            className="button button-danger justify-content-center ml-auto mr-auto mt-4"
          >
            {state.confirmButtonLabel}
          </Button>
        </div>
      </ModalView>
    </Container>
  );
};

const mapStateToProps = ({
  audiences,
  audienceSlice,
  clients,
  userProfile
}) => {
  return {
    userProfiles: userProfile.profiles,
    companyPlan: userProfile.companyPlan,
    user: userProfile.user,
    audiences: {
      ...audiences,
      isDublicateSuccess: audienceSlice.isDublicateSuccess
    },

    countries: audiences.countries,
    clients: clients.data,
    created: audiences.added,
    removedAudiences: audienceSlice.removedAudiences,
    isRemovedAudiencesLoading: audienceSlice.isRemovedAudiencesLoading,
    isRestoreAllAudiencesSuccess: audienceSlice.isRestoreAllAudiencesSuccess,
    isRestoreAudienceSuccess: audienceSlice.isRestoreAudienceSuccess,
    isPermanentRemoveAllSuccess: audienceSlice.isPermanentRemoveAllSuccess,
    isAudienceRemoveSuccess: audiences.isAudienceRemoveSuccess
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Trash);

Trash.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    }),
    role: PropTypes.string
  }).isRequired,
  audiences: PropTypes.shape({
    presets: PropTypes.arrayOf(PropTypes.shape({})),
    data: PropTypes.arrayOf(PropTypes.shape({})),
    audiencesNext: PropTypes.string,
    presetsNext: PropTypes.string,
    audiencesOffset: PropTypes.number,
    presetsOffset: PropTypes.number,
    isLoadingAudiences: PropTypes.bool,
    isLoadingPresets: PropTypes.bool,
    isDublicateSuccess: PropTypes.bool.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.shape({}).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func
  }).isRequired,
  created: PropTypes.shape({
    id: PropTypes.string
  }),
  removedAudiences: PropTypes.arrayOf(PropTypes.shape({})),
  isRemovedAudiencesLoading: PropTypes.bool,
  isRestoreAllAudiencesSuccess: PropTypes.bool,
  isRestoreAudienceSuccess: PropTypes.bool,
  isPermanentRemoveAllSuccess: PropTypes.bool,
  isAudienceRemoveSuccess: PropTypes.bool
};

Trash.defaultProps = {
  created: {},
  removedAudiences: [],
  isRemovedAudiencesLoading: false,
  isRestoreAllAudiencesSuccess: false,
  isRestoreAudienceSuccess: false,
  isPermanentRemoveAllSuccess: false,
  isAudienceRemoveSuccess: false
};
